import {GeoPoint} from '../Models/GeoPoint';
import {Distance} from '../Domain/Distance';
import {Duration} from '../Domain/Duration';
import {GeoTrack} from '../Models/GeoTrack';
import {distanceBetweenGeoPoints} from './distanceBetweenGeoPoints';
import {Speed} from '../Domain/Speed';

/**
 * A section is the movement from one point to another.
 */
export interface GeoSegment {
    from: GeoPoint;
    to: GeoPoint;
    distance: Distance;
    duration: Duration;
    speed: Speed;
}

export function geoTrackToSegments(geoTrack: GeoTrack): GeoSegment[] {
    return geoTrack.reduce((p: GeoSegment[], c, index, data) => {
        // Skip the first point.
        if (index === 0) {
            return p;
        }

        // Get the previous point.
        const previousPoint = data[index - 1];

        // Calculate the distance between the points.
        const distance = distanceBetweenGeoPoints(previousPoint, c);

        // Calculate the duration between the points.
        const duration = c.elapsed_time.subtract(previousPoint.elapsed_time);

        // Add the section.
        p.push({
            from: previousPoint,
            to: c,
            distance,
            duration,
            speed: Speed.fromDistanceAndDuration(distance, duration),
        });

        // Return the sections.
        return p;
    }, []);
}
